import { ClientType } from '~/ApiClient';
export var SetReadError;
(function (SetReadError) {
})(SetReadError || (SetReadError = {}));
var SetReadRequest = /** @class */ (function () {
    function SetReadRequest(notificationIds) {
        this.api = ClientType.pigeon;
        this.knownErrorCodes = Object.values(SetReadError);
        this.method = 'put';
        this.body = JSON.stringify({
            notificationIds: notificationIds,
        });
        this.path = "notifications/read";
    }
    return SetReadRequest;
}());
export { SetReadRequest };
